<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title">{{ document.Document_Name }}{{ message }}</h3>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label>Document Title</label>
              <input class="form-control" type="text" v-model="document.Title">
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label>Background Color</label>
              <input class="form-control" type="text" v-model="document.Background_Color">
            </div>
          </div>
          <div class="col-xs-1">
            <div class="radio">
              <label>
                <input type="radio" id="opt1" value="1" v-model="picked">Filename
              </label>
            </div>
            <div class="radio">
              <label>
                <input type="radio" id="opt2" value="2" v-model="picked">Upload
              </label>
            </div>
          </div>
          <div class="col-xs-3">
            <div class="form-group" v-if="picked == 1">
              <label>PDF File To Use</label>
              <input class="form-control" type="text" v-model="document.PDF_Filename">
            </div>
            <div class="form-group" v-if="picked == 2">
              <label>Upload PDF</label>
              <input class="form-control" type="file" @change="onFileChange">
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer text-right">
        <button class="btn btn-primary" v-if="exists">View Page</button>
        <button class="btn btn-primary" @click="exists ? saveDocument() : createNew()">{{ exists ? 'Save Changes' : 'Add Document' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      updates: 0,
      message: "",
      picked: 1
    };
  },
  computed: {
    document() {
      return this.$store.getters.document;
    },
    exists() {
      return this.$store.getters.docExists;
    }
  },
  methods: {
    saveDocument() {
      var vm = this;
      this.$http
        .post("/peeb/updateDocument.php", this.document)
        .then(function(response) {
          if (response.data) {
            vm.updates += 1;
            vm.message = " has been updated " + vm.updates;
            vm.message += vm.updates > 1 ? " times" : " time";
          }
        });
      if (this.picked == 2) {
        console.log(this.file);
        var formData = new FormData();
        formData.append("file", this.file);
        this.$http
          .post("/peeb/uploadPDF.php", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(function(response) {
            console.log(response.data);
          });
          // .post("/peeb/uploadPDF.php", this.file)
          // .then(function(response) {
          //   console.log(response.data);
          // });
      }
    },
    createNew() {
      var vm = this;
      this.$http
        .post("/peeb/createDocument.php", this.document)
        .then(function(response) {
          if (Number.isInteger(response.data)) {
            vm.$store.dispatch("created");
            vm.message = " has been created!";
          }
        });
        if (this.picked == 2) {
        console.log(this.file);
        var formData = new FormData();
        formData.append("file", this.file);
        this.$http
          .post("/peeb/uploadPDF.php", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(function(response) {
            console.log(response.data);
          });
          // .post("/peeb/uploadPDF.php", this.file)
          // .then(function(response) {
          //   console.log(response.data);
          // });
      }
    },
    onFileChange(e) {
      var files = e.target.files;
      this.$store.dispatch("setPDF", files[0].name);
      this.file = files[0];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DocumentPanel.vue